import { SelectedTagData } from '@/common/components/templates/selectTargetTagWindow/selectTargetTagWindow.type';
import { ConfigGroupInfo, TargetTagType } from '@/common/utils';
import { LogStringTags } from '@/api-client/metav6/model';
import {
  LOG_TYPE_NAME_MAP,
  LOG_TYPE_VALUE_MAP,
  type LogTargetType,
} from '../components/logTarget/logTypeSelect.define';

export const convertSelectedTagDataToTarget = (
  item: SelectedTagData,
): `${string};${string};${string}` => `${item.groupTagId};${item.tagType};${item.tagId}`;

export const convertTagsToSelectedTagData = (item: LogStringTags): SelectedTagData => ({
  groupTagId: item.tagKey!,
  tagType: item.tagType as TargetTagType,
  tagId: item.tagValue!,
});

export const getLogTypeName = (logType: LogTargetType): string => {
  return LOG_TYPE_NAME_MAP?.[logType] ?? logType;
};

export const getLogTypeValue = (logDisplayName: string): LogTargetType => {
  return LOG_TYPE_VALUE_MAP?.[logDisplayName] ?? logDisplayName;
};

export const ALL_GROUP_ID = 'ALL';
export const getGroupStatus = (total: number, active: number): ConfigGroupInfo['status'] => {
  if (total === active && total > 0) {
    return 'ACTIVE';
  }
  if (total > active && active > 0) {
    return 'WARNING';
  }
  return 'INACTIVE';
};
